'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theme = require('../theme');

var _DefaultIndicator = require('./DefaultIndicator');

var _DefaultIndicator2 = _interopRequireDefault(_DefaultIndicator);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

// eslint-disable-line local-rules/no-deep-relative-imports
var LoadingUI = function (_React$PureComponent) {
  (0, _inherits3.default)(LoadingUI, _React$PureComponent);
  (0, _createClass3.default)(LoadingUI, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (props.progress !== state.loading) {
        return {
          loading: props.progress && props.delay === undefined
        };
      }
      return null;
    }
  }]);

  function LoadingUI(props) {
    (0, _classCallCheck3.default)(this, LoadingUI);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoadingUI.__proto__ || Object.getPrototypeOf(LoadingUI)).call(this, props));

    _this.componentDidUpdate = function () {
      if (_this.props.delay && _this.props.progress) {
        if (!_this.state.loading) {
          clearTimeout(_this.delayTimer);
          _this.delayTimer = setTimeout(function () {
            if (!_this.unmounted) {
              _this.setState({
                loading: true,
                delayStarted: false
              });
            }
          }, _this.props.delay);
        }
      } else {
        if (_this.delayTimer) {
          _this.stopDelayTimer();
        }
      }
    };

    _this.componentWillUnmount = function () {
      _this.unmounted = true;
      _this.stopDelayTimer();
    };

    _this.stopDelayTimer = function () {
      if (_this.delayTimer) {
        clearTimeout(_this.delayTimer);
      }
    };

    _this.indicator = null;
    _this.state = {
      delayStarted: false,
      loading: props.progress && props.delay === undefined
    };
    _this.unmounted = false;
    return _this;
  }

  (0, _createClass3.default)(LoadingUI, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          maskClassName = _props.maskClassName,
          disableMask = _props.disableMask,
          uia = _props.uia,
          htmlFor = _props.htmlFor,
          size = _props.size,
          indicator = _props.indicator,
          theme = _props.theme,
          children = _props.children,
          progress = _props.progress,
          indicatorContent = _props.indicatorContent,
          restProps = (0, _objectWithoutProperties3.default)(_props, ['className', 'maskClassName', 'disableMask', 'uia', 'htmlFor', 'size', 'indicator', 'theme', 'children', 'progress', 'indicatorContent']);


      var defaultIndicatorContent = indicatorContent;

      if (!defaultIndicatorContent && theme.components.loading.defaultIcon) {
        defaultIndicatorContent = _react2.default.createElement(_Icon2.default, { color: theme.components.loading.colorName, name: theme.components.loading.defaultIcon, size: size, uia: 'loading' });
      }

      if (!children) {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({ className: className, 'aria-busy': true, htmlFor: htmlFor, 'data-uia-loading': uia }, restProps),
          indicator ? indicator : _react2.default.createElement(_DefaultIndicator2.default, {
            size: size,
            theme: theme,
            indicatorContent: defaultIndicatorContent
          })
        );
      }

      if (!this.state.loading) {
        return children;
      } // short circle on embeded mode, do bypass when not loading

      return _react2.default.createElement(
        LoadingWrapper,
        (0, _extends3.default)({ className: className, 'aria-busy': progress, 'data-uia-loading': uia }, restProps),
        _react2.default.createElement(
          IndicatorWrapper,
          null,
          _react2.default.createElement(_DefaultIndicator2.default, {
            size: size,
            theme: theme,
            indicatorContent: defaultIndicatorContent
          }),
          !disableMask && _react2.default.createElement(LoadingMask, { className: maskClassName })
        ),
        children
      );
    }
  }]);
  return LoadingUI;
}(_react2.default.PureComponent);

var IndicatorWrapper = /*#__PURE__*/(0, _theme.styled)('div', {
  target: 'e1ozj5e70'
})({
  position: 'absolute',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around'
});

var LoadingWrapper = /*#__PURE__*/(0, _theme.styled)('div', {
  target: 'e1ozj5e71'
})('position:relative;display:inline-block;');

var LoadingMask = /*#__PURE__*/(0, _theme.styled)('div', {
  target: 'e1ozj5e72'
})('width:100%;height:100%;position:absolute;', function (_ref) {
  var theme = _ref.theme;

  return '\n      background-color: ' + theme.components.loading.mask.backgroundColor + ';\n      opacity: ' + theme.components.loading.mask.opacity + ';\n    ';
});

var Loading = /*#__PURE__*/(0, _theme.styled)((0, _theme.withTheme)(LoadingUI), {
  target: 'e1ozj5e73'
})();

Loading.propTypes = {
  /**
   * container which loading to wrap
   */
  children: _propTypes2.default.node,
  /**
   * Component class name
   */
  className: _propTypes2.default.string,
  /**
   * delay in miniseconds
   */
  delay: _propTypes2.default.number,
  /**
   * spinner component
   */
  indicator: _propTypes2.default.node,
  /**
   * content that goes in the middle of the defualt spinner
   */
  indicatorContent: _propTypes2.default.node,
  /**
   * loading state flag
   */
  progress: _propTypes2.default.bool,
  /**
   * size of the component
   */
  size: _propTypes2.default.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xxlarge', 'xxxlarge']),
  /**
   * theme object
   */
  theme: _propTypes2.default.object,
  uia: _propTypes2.default.string,
  // Prop used for visual testing so that tests dont fail due to animation
  htmlFor: _propTypes2.default.string
};

Loading.defaultProps = {
  size: 'medium'
};

/**
 * @component
 */
exports.default = Loading;